import ConfigurableQuestionModal from './ConfigurableQuestionModal';

export default ConfigurableQuestionModal;
